import {EffectCallback, useEffect} from 'react';

export const useFocusEffect = (effect: EffectCallback): void => {
  useEffect(effect, [effect]);
};
